<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="600">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-eye</v-icon> Visualizar Função
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-row class="justify-center mt-7">
            <v-col cols="12">
              <v-text-field
                :value="content.nome"
                label="Nome da Função"
                readonly
                outlined
                dense
              ></v-text-field>
              <v-text-field
                :value="content.tipo.descricao"
                label="Tipo da Função"
                readonly
                outlined
                dense
              ></v-text-field>
              <v-textarea
                :value="content.descricao"
                label="Atividades Desempenhadas"
                maxlength="250"
                counter="250"
                readonly
                outlined
                dense
                rows="4"
              ></v-textarea>
            </v-col>
          </v-row>
        </div>
        <div class="btn-group text-center">
          <v-btn color="primary" @click="$emit('onClose')">
            Fechar
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { Funcao } from '~/commons/classes/funcao';

export default {
  props: new DialogProps(Funcao),
}
</script>